import createApiClient from "./api";

const api = createApiClient("/safety");

const getQuestionId = (q) => q.id || q._id;

const normalizeInspection = (inspection) => ({
  ...inspection,
  _id: inspection._id || inspection.id,
});

export const fetchSafetyQuestions = async (projectId) => {
  const response = await api.get("/questions", {
    params: { project_id: projectId },
  });
  const { data, total } = response.data;
  return {
    questions: (data || []).map((q) => ({ ...q, id: getQuestionId(q) })),
    total: total ?? (data || []).length,
  };
};

export const createSafetyQuestion = async (payload) => {
  const response = await api.post("/questions", payload);
  const q = response.data;
  return { ...q, id: getQuestionId(q) };
};

export const updateSafetyQuestion = async (questionId, payload) => {
  const response = await api.put(`/questions/${questionId}`, payload);
  const q = response.data;
  return { ...q, id: getQuestionId(q) };
};

export const deleteSafetyQuestion = async (questionId) => {
  const response = await api.delete(`/questions/${questionId}`);
  return response.data;
};

export const reorderSafetyQuestions = async (projectId, items) => {
  const response = await api.put("/questions/reorder", {
    project_id: projectId,
    items,
  });
  return response.data;
};

export const bulkCreateSafetyQuestions = async ({ projectId, questions }) => {
  const response = await api.post("/questions/bulk", {
    project_id: projectId,
    questions,
  });
  return response.data;
};

export const copySafetyQuestionsFromProject = async (
  sourceProjectId,
  targetProjectId
) => {
  const response = await api.post("/questions/copy-from-project", {
    source_project_id: sourceProjectId,
    target_project_id: targetProjectId,
  });
  return response.data;
};

export const fetchSafetyInspectionByDate = async ({ projectId, date }) => {
  const formattedDate = date?.format ? date.format("YYYY-MM-DD") : date;
  const response = await api.get("/inspections/from-date", {
    params: {
      project_id: projectId,
      date: formattedDate,
    },
  });
  return normalizeInspection(response.data);
};

export const updateSafetyInspection = async (inspectionId, payload) => {
  const response = await api.put(`/inspections/${inspectionId}`, payload);
  return normalizeInspection(response.data);
};

export const generateSafetyInspectionPdf = async (inspectionId) => {
  const response = await api.post(
    `/inspections/${inspectionId}/generate-pdf`,
    {}
  );
  return response.data;
};
